import React from "react";
import styles from "./styles.css";
import Proptypes from "prop-types";
import LazyImage from "../../shared/lazy-image";
import singleRating from "./images/singleStar.svg";
import StarRating from "../../shared/star-rating/starRating";

const HappyBuyerReviewCard = ({ rating, number, productIcon, reviewLink, showSingleStar = false }) => {
    return (
        <div styleName={showSingleStar ? "styles.buyerReviewCardSingleCard" : "styles.cardOuter"}>
            <a href={reviewLink}>
                <div styleName={showSingleStar ? "styles.singleStarRating" : "styles.rating"}>
                    <div>{rating}</div>
                    {showSingleStar && <img src={singleRating} alt="star" />}
                    <div styleName="styles.ratingRelativeNumber">
                        <div styleName={showSingleStar ? "styles.singleStarRatingNumber" : "styles.ratingNumber"}>
                        ({number})
                        </div>
                    </div>
                </div>

                {!showSingleStar && (
                    <div styleName="styles.cardOuterImg">
                        <StarRating rating={parseFloat(rating)} />
                    </div>
                )}

                <div styleName={"styles.productLogo"}>
                    <LazyImage width="108" height="22" styleName={"styles.productLogoImg"} src={productIcon} />
                </div>
            </a>
        </div>
    );
};

HappyBuyerReviewCard.propTypes = {
    rating: Proptypes.string,
    number: Proptypes.string,
    productIcon: Proptypes.string,
    reviewLink: Proptypes.string,
    showSingleStar: Proptypes.bool
};

export default HappyBuyerReviewCard;
